import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFullscreenExitComponent } from "./med-icon-fullscreen-exit.component";

@NgModule({
  declarations: [
    MedIconFullscreenExitComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFullscreenExitComponent,
  ],
})
export class MedIconFullscreenExitModule { }
